import { Link,useNavigate } from "react-router-dom";
import "./products.css"
//import "../../pages/app-wide.css";

const ProductContainer = ({}) => {


  return (
    <div className="product-home-container-whole">
        <div className="product-home-container-whole-inner">

            <div className="product-home-top-header">
                <div>
                    <p className="product-home-sub-header">Solutions</p>
                </div>
                <div>
                    <p className="product-home-header">Make Investing Simple using our Products</p>
                </div>
            </div>

            <div className="product-home-container-item">

                <div className="product-home-container-item-inner">

                    <div className="product-home-container-item-left">
                        <p className="product-home-container-item-left-title">Stock API</p>
                        <p className="product-home-container-item-left-sub-title">Stock Archives API provides key endpoints
                            for historic stock information with an easy to access api.</p>
                        <p className="product-home-container-item-left-sub-title">Historical Balance Sheet, Income Statement, Cashflow</p>
                    </div>

                    <div className="product-home-container-item-right">
                        <svg
                        className="svg-item"
                        viewBox="0 0 550 550"
                        width="100%"
                        height="100%"
                        preserveAspectRatio="xMidYMid meet"
                        >
                            <defs>
                                <linearGradient id="strokeGradient" x1="0%" y1="0%" x2="100%" y2="0%">
                                <stop offset="45%" stop-color="#296BE2" />
                                <stop offset="100%" stop-color="#050B13" />
                                </linearGradient>

                                <clipPath id="clipCircle">
                                    <circle cx="83" cy="83" r="70" />
                                </clipPath>
                            </defs>

                            <defs>
                                <linearGradient id="rectGradient" x1="0%" y1="0%" x2="100%" y2="0%">
                                <stop offset="0%" stop-color="#296BE2" />
                                <stop offset="100%" stop-color="#050B13" />
                                </linearGradient>
                            </defs>

                            <defs>
                                <linearGradient id="strokeGradient2" x1="0%" y1="0%" x2="100%" y2="0%">
                                <stop offset="0%" stop-color="#296BE2" />
                                <stop offset="100%" stop-color="#050B13" />
                                </linearGradient>
                                <clipPath id="clipCircle2">
                                    <rect x="120" y="0" width="200" height="100" />
                                </clipPath>
                            </defs>

                            <defs>
                                <linearGradient id="strokeGradient3" x1="0%" y1="0%" x2="100%" y2="0%">
                                <stop offset="50%" stop-color="#296BE2" />
                                <stop offset="100%" stop-color="#050B13" />
                                </linearGradient>
                                <clipPath id="clipCircle2">
                                    <rect x="120" y="0" width="200" height="100" />
                                </clipPath>
                            </defs>

                            <defs>
                                <filter id="circleShadow" x="-50%" y="-50%" width="200%" height="200%">
                                    <feDropShadow
                                    dx="0"
                                    dy="8"
                                    stdDeviation="15"
                                    flood-color="rgba(0, 0, 0, 0.6)"
                                    />
                                </filter>
                            </defs>

                            <circle
                                cx="40"
                                cy="180"
                                r="175"
                                fill="none"
                                stroke="url(#strokeGradient)"
                                stroke-width="3"
                            />
                            <circle
                                cx="500"
                                cy="375"
                                r="175"
                                fill="none"
                                stroke="url(#strokeGradient3)"
                                stroke-width="3"
                            />

                            <circle
                                cx="250"
                                cy="275"
                                r="250"
                                fill="#050B13"
                                stroke="url(#strokeGradient)"
                                stroke-width="3"
                                filter="url(#circleShadow)"
                            />

                            <rect
                                x="-175"
                                y="475"
                                width="250"
                                height="5"
                                fill="url(#rectGradient)"
                                rx="12"
                            />

                            <circle
                                cx="-170"
                                cy="475"
                                r="10"
                                fill="#296BE2"
                                stroke-width="3"
                            />

                            <rect
                                x="-650"
                                y="150"
                                width="350"
                                height="5"
                                fill="url(#rectGradient)"
                                rx="12"
                                transform="translate(200, 0) scale(-1, 1)"
                            />

                            <circle
                                cx="850"
                                cy="150"
                                r="10"
                                fill="#296BE2"
                                stroke-width="3"
                            />

                            <text
                                x="-140"
                                y="460"
                                font-size="30"
                                font-weight="300"
                                fill="#FFFFFF"
                            >
                                +25 Years
                            </text>


                            <text
                                x="490"
                                y="140"
                                font-size="30"
                                font-weight="300"
                                fill="#FFFFFF"
                            >
                                +20 Unique Data Points
                            </text>
                        </svg>






                    </div>

                </div>

            </div>
        </div>
    </div>
  );
};

export default ProductContainer;